import "./WizardStepFooter.scss";

export const StepFooter = "stepFooter";

export function stepFooter() {
    return {
        template: "<ng-transclude></ng-transclude>",
        transclude: true,
    };
}
